import { useCurrentRoute } from '../CurrentRouteContext';

const routesToHideMenu = ['confirm-email', 'email-verify', 'pricing'];

export function useShouldHideHeader() {
  const selectedRoute = useCurrentRoute();
  return routesToHideMenu.includes(selectedRoute);
}